"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaDropdown = require("./AaDropdown.model");

var _AaHoverable = _interopRequireDefault(require("../../utils/airasia-hover/AaHoverable"));

var _AaIcon = _interopRequireDefault(require("../airasia-icon-component/AaIcon.component"));

var _uiUtils = require("@airasia/ui-utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AaAutocompleteOption = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(AaAutocompleteOption, _PureComponent);

  var _super = _createSuper(AaAutocompleteOption);

  function AaAutocompleteOption() {
    var _this;

    (0, _classCallCheck2["default"])(this, AaAutocompleteOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePress", function () {
      var _this$props$controls = _this.props.controls,
          onOptionPress = _this$props$controls.onOptionPress,
          item = _this$props$controls.item,
          index = _this$props$controls.index;
      onOptionPress(item, index);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getBoldComponents", function (label, value) {
      var textWithBold = label;

      if (value && label) {
        var pIdx = label.toLowerCase().indexOf(value.toLowerCase());

        if (pIdx >= 0) {
          textWithBold = [label.substring(0, pIdx), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
            style: styles.highlightedText,
            key: _this.props.keyEle
          }, label.substring(pIdx, pIdx + value.length)), label.substring(pIdx + value.length)];
        }
      }

      return textWithBold;
    });
    return _this;
  }

  (0, _createClass2["default"])(AaAutocompleteOption, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$controls2 = this.props.controls,
          item = _this$props$controls2.item,
          primaryLabel = _this$props$controls2.primaryLabel,
          secondaryLabel = _this$props$controls2.secondaryLabel,
          subtitleLabel = _this$props$controls2.subtitleLabel,
          labelContainerStyles = _this$props$controls2.labelContainerStyles,
          labelTextStyle = _this$props$controls2.labelTextStyle,
          value = _this$props$controls2.value,
          isNewDesign = _this$props$controls2.isNewDesign;
      var primaryText = this.getBoldComponents(item[primaryLabel], value);
      var secondaryText = this.getBoldComponents(item[secondaryLabel], value);
      var subtitleText = this.getBoldComponents(item[subtitleLabel], value);
      var hasSecondaryLabel = Boolean(secondaryLabel) && item[secondaryLabel];
      var iconStyle = isNewDesign ? styles.iconStyle : {};
      return /*#__PURE__*/_react["default"].createElement(_AaHoverable["default"], null, function (isHovered) {
        return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: [styles.container, labelContainerStyles, _this2.props.controls.selectedIndex && {
            backgroundColor: "#f2f2f2"
          }, isHovered && {
            backgroundColor: "#f2f2f2"
          }]
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableOpacity, {
          accessible: _reactNativeWeb.Platform.OS !== 'web',
          onPress: _this2.handlePress,
          style: styles.labelContainerStyles
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: [styles.labelDefaultStyles]
        }, item.hasOwnProperty("labelIcon") && /*#__PURE__*/_react["default"].createElement(_AaIcon["default"], {
          controls: {
            iconName: item.labelIcon,
            iconStyle: iconStyle
          }
        }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: newDesignStyles.labelsContainer
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: styles.labelContainerStyles
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
          style: [styles.autocompleteOptionText, styles.styleText, labelTextStyle, item.labelTextStyle]
        }, primaryText), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, null, '  '), hasSecondaryLabel && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: [styles.secondaryLabel, _this2.props.controls.selectedIndex && styles.secondaryLabelOnHover, isHovered && styles.secondaryLabelOnHover]
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
          style: [styles.autocompleteOptionText, styles.styleText, labelTextStyle, item.labelTextStyle]
        }, secondaryText))), isNewDesign && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
          style: newDesignStyles.subtitleLabel
        }, subtitleText))), isNewDesign && item.hasOwnProperty('type') && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: newDesignStyles.typeLabelContainer
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
          style: newDesignStyles.typeLabel
        }, item.type)), item.hasOwnProperty("labelIndicator") && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: [styles.labelIndicatorStyle]
        }, /*#__PURE__*/_react["default"].createElement(_AaIcon["default"], {
          controls: {
            iconName: item.labelIndicator,
            iconStyle: styles.iconStyle
          }
        }))));
      });
    }
  }]);
  return AaAutocompleteOption;
}(_react.PureComponent);

var styles = _StyleSheet["default"].create({
  container: {
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    fontSize: 16,
    web: {
      flex: 1,
      flexDirection: 'row',
      width: '100%',
      minHeight: 44
    }
  },
  iconStyle: {
    width: 24,
    height: 24,
    lineHeight: 24
  },
  autocompleteOptionText: {
    fontSize: 14
  },
  labelContainerStyles: {
    flex: 1,
    flexDirection: 'row'
  },
  labelDefaultStyles: {
    flex: 5,
    flexDirection: 'row',
    alignItems: 'center'
  },
  labelIndicatorStyle: {
    flex: 3,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    web: {
      flex: 1,
      justifyContent: 'flex-end',
      alignItems: 'center'
    }
  },
  secondaryLabel: {
    padding: 3,
    borderRadius: 3
  },
  secondaryLabelOnHover: {
    backgroundColor: "#fff"
  },
  highlightedText: {
    fontWeight: 'bold'
  },
  styleText: {
    color: '#1d1d1d',
    fontSize: 16,
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontWeight: '400',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  }
});

var newDesignStyles = _StyleSheet["default"].create({
  labelsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  subtitleLabel: {
    fontSize: 12,
    lineHeight: 18,
    color: '#75767A',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  },
  typeLabelContainer: {
    fontSize: 12,
    lineHeight: 18,
    maxHeight: 26,
    paddingHorizontal: 3,
    paddingVertical: 4,
    backgroundColor: '#EDEDF6',
    borderRadius: 3
  },
  typeLabel: {
    color: '#4448A0',
    textTransform: 'capitalize',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      marginVertical: 'auto'
    }
  }
});

var _default = AaAutocompleteOption;
exports["default"] = _default;